<section class="not-found-container w-100 h-100 flex flex-column justify-content-center align-items-center gap-40">
  <img [src]="notFoundImage" width="160" height="193" />
  <div class="not-found-messages flex flex-column justify-content-center align-items-center gap-16">
    <p>Ops, parece que você se perdeu.</p>
    <p>Mas não se preocupe, é <b>fácil de resolver!</b></p>
  </div>
  <button class="not-found-button" (click)="navigateToLogin()">Voltar para o início</button>
  <img class="not-found-branding" [src]="brandingImage" />
</section>
